var _path, _path2, _line, _line2, _path3, _path4, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorAirlinesCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.237,28.245v-8.435c0-1.948-1.54-3.524-3.467-3.607-1.214,1.371-2.968,2.253-4.943,2.253s-3.729-.882-4.943-2.253c-1.927.083-3.467,1.659-3.467,3.607v8.435"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.457,39.016v-6.964h.894c1.052,0,1.904-.852,1.904-1.904h0c0-1.052-.852-1.904-1.904-1.904H5.65c-1.052,0-1.904.852-1.904,1.904h0c0,1.052.852,1.904,1.904,1.904h1.005v6.964"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.006,
    y1: 27.977,
    x2: 17.006,
    y2: 22.144
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24.571,
    y1: 27.977,
    x2: 24.571,
    y2: 22.144
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.943,3.489h4.216c1.001,0,1.815.813,1.815,1.815v2.528h-7.845v-2.528c0-1.001.813-1.815,1.815-1.815Z",
    transform: "translate(2.055 -5.223) rotate(14.162)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.375,6.877c-1.75,1.035-2.668,3.138-2.087,5.186.691,2.437,3.228,3.853,5.665,3.161s3.853-3.228,3.161-5.665c-.102-.361-.256-.692-.433-1.004l-6.306-1.678Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.654,
    y1: 32.052,
    x2: 35.457,
    y2: 32.052
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorAirlinesCounter);
export default __webpack_public_path__ + "static/media/indoor-airlines_counter.845a5cbbf82e40788f1bf2b4f9fd7022.svg";
export { ForwardRef as ReactComponent };